import React from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { useSelector } from "react-redux";
import { useTrackVICheckedBaggage } from "../../../utils/experiments/funnel/flights_funnel_web_vi_checked_baggage.js";
import { WishlistWidgetWrapper } from "../WishlistWidgetWrapper/index.js";
import { SurveyTrackerLoader } from "../../remote/SurveyTrackerFlightsUniversal.js";
import { getFlightError } from "../../../store/flightDetails/selectors.js";
import { useFlightDetailsInnerMobileController } from "./useFlightDetailsInner.mobile.controller.js";
import { useFlightDetailsInnerEffectsMobile } from "./useFlightDetailsInnerEffects.mobile.js";
import { FlightDetailsFooterMobile } from "./components/FlightDetailsFooter/FlightDetailsFooter.mobile.js";
import FlightDetailsErrorMobile from "./components/FlightDetailsError.mobile.js";
import { FlightDetailsBanner } from "./components/FlightDetailsBanner.js";
import { Container, Spinner, Stack, Text } from "@bookingcom/bui-react";
import { FlightDetailsTimelineNewMobile } from "./components/FlightDetailsTimeline/index.js";
import { GeniusRewardsInfoMobile } from "./components/FlightDetailsInfo/Items/GeniusRewardsInfo/GeniusRewardsInfo.mobile.js";
import { FlightDetailsLegalFooterMobile } from "./components/FlightDetailsLegalFooter.mobile.js";
import FlightDetailsInfoTabsMobile from "./components/FlightDetailsInfo/FlightDetailsInfoTabs.mobile.js";
import { getSearchType } from "../../../store/search/selectors.js";
const FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID = "flight-details-sticky-footer-spacer";
function LoadingSkeleton() {
    const i18n = useI18n();
    return (React.createElement(Stack, { gap: 2, direction: "row" },
        React.createElement(Spinner, null),
        React.createElement(Text, null, i18n.trans(t("flights_fd_loading_more")))));
}
export function FlightDetailsInnerNewMobile(props) {
    const { flight, flightToken, fetchStatus, onClose, onErrorClose, hideFooter, hasPrefetchedBrandedFareOffers, alternativeFaresFlow } = props;
    const i18n = useI18n();
    const flightDetailsError = useSelector(getFlightError);
    const searchType = useSelector(getSearchType);
    const { isError, trackV2, modalTitle, closeBtnRef, onFlightSelect, campaignBadges, shouldShowWishlistWidget } = useFlightDetailsInnerMobileController({
        flight,
        flightToken,
        alternativeFaresFlow,
        hasPrefetchedBrandedFareOffers
    });
    useFlightDetailsInnerEffectsMobile({ flightToken, flight, isError, trackV2 });
    useTrackVICheckedBaggage();
    if (isError) {
        return (React.createElement(FlightDetailsErrorMobile, { onClose: onClose, onErrorClose: onErrorClose, flightDetailsError: flightDetailsError }));
    }
    return (React.createElement(Stack, { gap: 4 },
        React.createElement(FlightDetailsBanner, { title: modalTitle, campaignBadges: campaignBadges, toIata: searchType !== "MULTISTOP" ? flight?.segments?.[0]?.arrivalAirport?.code : undefined, backButton: {
                attributes: {
                    ref: closeBtnRef,
                    "aria-label": i18n.trans(t("a11y_flights_mdot_fd_back"))
                },
                onClick: () => {
                    trackV2("click_back_button");
                    onClose();
                }
            }, favoriteButton: flight && shouldShowWishlistWidget && flight.offerKeyToHighlight ? (React.createElement(WishlistWidgetWrapper, { flight: flight })) : undefined }),
        flight ? (React.createElement(Container, null,
            React.createElement(Stack, { gap: 4, mixin: { marginBlockEnd: 4 } },
                React.createElement(FlightDetailsTimelineNewMobile, { flight: flight }),
                flight && fetchStatus === "loading" ? (React.createElement(LoadingSkeleton, null)) : flight ? (React.createElement(React.Fragment, null,
                    React.createElement(FlightDetailsInfoTabsMobile, { flight: flight, fetchStatus: fetchStatus }),
                    React.createElement(GeniusRewardsInfoMobile, { flight: flight }),
                    fetchStatus === "success" && React.createElement(SurveyTrackerLoader, null),
                    React.createElement(FlightDetailsLegalFooterMobile, { mixin: { marginBlockEnd: 2 }, flight: flight }))) : undefined))) : (React.createElement(Container, null,
            React.createElement(LoadingSkeleton, null))),
        !hideFooter && (React.createElement(React.Fragment, null,
            React.createElement("div", { id: FLIGHT_DETAILS_STICKY_FOOTER_SPACER_ID }),
            React.createElement(FlightDetailsFooterMobile, { flight: flight, onButtonClick: onFlightSelect })))));
}
